/* import __COLOCATED_TEMPLATE__ from './registry.hbs'; */
import Component from '@glimmer/component';
import { faker } from '@faker-js/faker';
export default class MockAvatar extends Component {
  get lorem() {
    return faker.lorem.paragraphs({
      min: 1,
      max: 5
    }, '\n').split('\n');
  }
}